<template>
  <div class="FinancesPayoutsExtraPaymentsTable">
    <b-table :fields="fields" :items="items">
      <template #cell(cost)="{ item, index }">
        <div>
          <b-form-input
            type="number"
            no-wheel
            v-model="item.cost"
            @input="dataTouched(index, 'cost')"
          />
          <span class="currency-code">{{ currencyCode }}</span>
        </div>
      </template>
      <template #cell(description)="{ item, index }">
        <b-form-textarea
          id="textarea"
          v-model="item.description"
          rows="3"
          max-rows="6"
          @input="dataTouched(index, 'description')"
        >
        </b-form-textarea>
      </template>
      <template #cell(actions)="data" v-if="items.length >= 1">
       <b-button variant="danger" size="sm" @click.prevent="removeItem(data)">
         <font-awesome-icon icon="trash" />
       </b-button>
      </template>
    </b-table>
    <b-button @click.prevent="addItem" variant="info">
      Add payment
    </b-button>
  </div>
</template>

<script>
import { cloneDeep } from 'lodash'

const defaultItem = {
  'cost': null,
  'description': null
}

export default {
  props: {
    value: {
      type: Array,
      default: () => []
    },
    currencyCode: {
      type: String,
      default: ''
    }
  },
  data () {
    return {
      fields: [
        { key: 'cost', label: 'Cost', class: 'cost-column' },
        { key: 'description', label: 'Description', class: 'description-column' },
        { key: 'actions', label: '', class: 'actions-column' }
      ],
      items: []
    }
  },
  mounted () {
    this.setInitialParams()
  },
  watch: {
    'value': {
      deep: true,
      handler () {
        this.setInitialParams()
      }
    }
  },
  methods: {
    setInitialParams () {
      this.items = this.value || []
      this.triggerInputEmit()
    },
    addItem () {
      this.items.push(cloneDeep(defaultItem))
      this.triggerInputEmit()
    },
    removeItem (data) {
      const removedIndex = data.index
      this.items = this.items.filter((item, index) => index !== removedIndex)
      this.dataTouched(data.index, null)
      this.triggerInputEmit()
      this.$emit('dataRemoved', { removedIndex })
    },
    triggerInputEmit () {
      this.$emit('input', this.items)
    },
    dataTouched (index, attrName) {
      this.$emit('dataTouched', { index, attrName })
    }
  }
}
</script>

<style lang="scss">
  .FinancesPayoutsExtraPaymentsTable{
    margin-bottom: 1rem;
    .actions-column {
      min-width: 40px;
    }
    .cost-column {
      width: 120px;
    }
    .description-column {
      width: auto;
    }
    .currency-code {
      float: right;
      margin-top: -28px;
      margin-right: 4px;
    }
  }
</style>
